export const ReconciliationActionTypes = {
  ASYNC_RECONCILIATIONS: '@reconciliation/ASYNC_RECONCILIATIONS',
  GET_RECONCILIATIONS: '@reconciliation/GET_RECONCILIATIONS',
  ASYNC_RECONCILIATION: '@reconciliation/ASYNC_RECONCILIATION',
  ASYNC_RECONCILIATION_DAYS: '@reconciliation/ASYNC_RECONCILIATION',
  ASYNC_DAY_DETAILS: '@reconciliation/ASYNC_DAY_DETAILS',
  SET_DAY_DETAILS: '@reconciliation/SET_DAY_DETAILS',
  ASYNC_UPLOAD_URl_FILE: '@reconciliation/ASYNC_UPLOAD_URl_FILE',
  SET_RECONCILIATION: '@reconciliation/SET_RECONCILIATION',
  SUCCESS: '@reconciliation/SUCCESS',
  LOADING: '@reconciliation/LOADING',
  LOADING_DAYS_LIST: '@reconciliation/LOADING_DAYS_LIST',
  ASYNC_RECONCILIATIONS_DAYS_LIST: '@reconciliation/ASYNC_RECONCILIATIONS_DAYS_LIST',
  SET_RECONCILIATIONS_DAYS_LIST: '@reconciliation/SET_RECONCILIATIONS_DAYS_LIST',
  ASYNC_WEBHOOKS_DETAILS: '@reconciliation/ASYNC_WEBHOOKS_DEATILS',
  SET_WEBHOOKS_DETAILS: '@reconciliation/SET_WEBHOOKS_DETAILS',
  LOADING_WEBHOOK: '@reconciliation/LOADING_WEBHOOK',
  ASYNC_WEBHOOK_PUT:'@reconciliation/ASYNC_WEBHOOK_PUT',
  ASYNC_WEBHOOK_DELETE:'@reconciliation/ASYNC_WEBHOOK_DELETE',
  ASYNC_LIST_WEBHOOK_INVOCATION: '@reconciliation/ASYNC_LIST_WEBHOOK_INVOCATION',
  SET_LIST_WEBHOOK_INVOCATION: '@reconciliation/SET_LIST_WEBHOOK_INVOCATION',
  LOADING_LIST_WEBHOOK_INVOCATION: '@reconciliation/LOADING_LIST_WEBHOOK_INVOCATION',
}

const INITIAL_STATE = {
  reconciliations: [],
  reconciliation: {},
  dayDetails: {},
  loading: false,
  loadingDaysList: false,
  success: false,
  reconciliationsDaysList: [],
  webhooksDetails: null,
  loadingWebhook: false,
  listWebhookInvocations: {},
  loadingListWebhookInvocations: false
}

export const asyncListWebhookInvocations = (payload) => ({
  type: ReconciliationActionTypes.ASYNC_LIST_WEBHOOK_INVOCATION,
  payload
})

export const seListWebhookInvocations = (payload) => ({
  type: ReconciliationActionTypes.SET_LIST_WEBHOOK_INVOCATION,
  payload,
});

export const setLoadingListWebhookInvocations = (payload) => ({
  type: ReconciliationActionTypes.LOADING_LIST_WEBHOOK_INVOCATION,
  payload
});

export const asyncDayDetails = (payload) => ({
  type: ReconciliationActionTypes.ASYNC_DAY_DETAILS,
  payload,
});

export const setDayDetails = (payload) => ({
  type: ReconciliationActionTypes.SET_DAY_DETAILS,
  payload,
});

export const setReconciliation = (payload) => ({
  type: ReconciliationActionTypes.SET_RECONCILIATION,
  payload,
});

export const setReconciliations = (payload) => ({
  type: ReconciliationActionTypes.GET_RECONCILIATIONS,
  payload
});

export const asyncUploadUrlFile = (params) => ({
  type: ReconciliationActionTypes.ASYNC_UPLOAD_URl_FILE,
  payload: params
});

export const asyncReconciliationDays = (params) => ({
  type: ReconciliationActionTypes.ASYNC_RECONCILIATION_DAYS,
  payload: params
});

export const setSuccess = (payload) => ({
  type: ReconciliationActionTypes.SUCCESS,
  payload
});

export const setLoading = (payload) => ({
  type: ReconciliationActionTypes.LOADING,
  payload
});

export const setLoadingDaysList = (payload) => ({
  type: ReconciliationActionTypes.LOADING_DAYS_LIST,
  payload
});

export const asyncReconciliations = (params) => ({
  type: ReconciliationActionTypes.ASYNC_RECONCILIATIONS,
  payload: params
})

export const asyncReconciliation = (params) => ({
  type: ReconciliationActionTypes.ASYNC_RECONCILIATION,
  payload: params
})

export const asyncReconciliationsDaysList = (payload) => (({
  type: ReconciliationActionTypes.ASYNC_RECONCILIATIONS_DAYS_LIST,
  payload,
}))

export const setReconciliationsListDays = (params) => (({
  type: ReconciliationActionTypes.SET_RECONCILIATIONS_DAYS_LIST,
  payload: params,
}))

export const asyncWebhookDetails = (payload) => (({
  type: ReconciliationActionTypes.ASYNC_WEBHOOKS_DETAILS,
  payload,
}))

export const setWebhookDetails = (params) => (({
  type: ReconciliationActionTypes.SET_WEBHOOKS_DETAILS,
  payload: params,
}))

export const setLoadingWebhook = (payload) => (({
  type: ReconciliationActionTypes.LOADING_WEBHOOK,
  payload,
}))

export const asyncWebhooksPut = (payload) => (({
  type: ReconciliationActionTypes.ASYNC_WEBHOOK_PUT,
  payload,
}))

export const asyncWebhooksDelete = (payload) => (({
  type: ReconciliationActionTypes.ASYNC_WEBHOOK_DELETE,
  payload,
}))

export const reconciliationReducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case ReconciliationActionTypes.SET_RECONCILIATION:
      return {
        ...state,
        reconciliation: payload
      };
    case ReconciliationActionTypes.SET_DAY_DETAILS:
      return {
        ...state,
        dayDetails: payload
      };
    case ReconciliationActionTypes.SUCCESS: return {
      ...state,
      success: payload
    }
    case ReconciliationActionTypes.LOADING:
      return { ...state, loading: payload }
    case ReconciliationActionTypes.LOADING_DAYS_LIST:
      return { ...state, loadingDaysList: payload }
    case ReconciliationActionTypes.GET_RECONCILIATIONS:
      return { ...state, reconciliations: payload };
    case ReconciliationActionTypes.SET_RECONCILIATIONS_DAYS_LIST:
      return {
        ...state,
        reconciliationsDaysList: payload,
      }
    case ReconciliationActionTypes.SET_WEBHOOKS_DETAILS:
        return { ...state, webhooksDetails: payload };
    case ReconciliationActionTypes.LOADING_WEBHOOK:
      return { ...state, loadingWebhook: payload };
    case ReconciliationActionTypes.SET_LIST_WEBHOOK_INVOCATION: {
      return { ...state, listWebhookInvocations: payload }
    }
    case ReconciliationActionTypes.LOADING_LIST_WEBHOOK_INVOCATION: {
      return { ...state, loadingListWebhookInvocations: payload }
    }
    default:
      return state;
  }
};

export default reconciliationReducer;
